var _symbol, _symbol2, _symbol3, _symbol4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpritemedalsKo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "gold",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.612 4.73999V5.82799H15.924V4.73999H6.612ZM4.948 10.068V11.156H18.052V10.068H4.948ZM15.06 4.73999V5.81199C15.06 7.01199 15.06 8.40399 14.58 10.388L15.876 10.452C16.356 8.45199 16.356 7.04399 16.356 5.81199V4.73999H15.06ZM6.548 13.124V18.26H16.404V13.124H6.548ZM15.108 14.18V17.188H7.844V14.18H15.108Z",
    fill: "black"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "silver",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.464 11.788V12.876H18.536V11.788H5.464ZM7.16 17.244V18.332H17.096V17.244H7.16ZM7.16 14.14V17.58H8.488V14.14H7.16ZM12.008 4.66803C8.904 4.66803 6.92 5.75603 6.92 7.56403C6.92 9.35603 8.904 10.444 12.008 10.444C15.096 10.444 17.096 9.35603 17.096 7.56403C17.096 5.75603 15.096 4.66803 12.008 4.66803ZM12.008 5.75603C14.28 5.75603 15.736 6.42803 15.736 7.56403C15.736 8.70003 14.28 9.37203 12.008 9.37203C9.736 9.37203 8.28 8.70003 8.28 7.56403C8.28 6.42803 9.736 5.75603 12.008 5.75603Z",
    fill: "black"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "bronze",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#DCB386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46399 11.068V12.156H18.536V11.068H5.46399ZM11.336 8.748V11.516H12.648V8.748H11.336ZM7.11199 8.332V9.42H17.016V8.332H7.11199ZM7.11199 4.604V8.972H8.42399V5.676H16.904V4.604H7.11199ZM11.976 13.196C8.88799 13.196 7.01599 14.14 7.01599 15.788C7.01599 17.468 8.88799 18.396 11.976 18.396C15.064 18.396 16.936 17.468 16.936 15.788C16.936 14.14 15.064 13.196 11.976 13.196ZM11.976 14.22C14.248 14.22 15.592 14.796 15.592 15.788C15.592 16.796 14.248 17.356 11.976 17.356C9.71999 17.356 8.35999 16.796 8.35999 15.788C8.35999 14.796 9.71999 14.22 11.976 14.22Z",
    fill: "black"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "total",
    viewBox: "0 0 27 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 6,
    r: 6,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 18,
    r: 6,
    fill: "#DCB386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpritemedalsKo);
export default __webpack_public_path__ + "static/media/Spritemedals_ko.d229115f7da008389a67b9148bc9d8b7.svg";
export { ForwardRef as ReactComponent };